import { render } from "./ViewTemplates.vue?vue&type=template&id=751a41a4"
import script from "./ViewTemplates.vue?vue&type=script&lang=js"
export * from "./ViewTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__